/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const appVersionPageMessages = defineMessages({
    browserTitle: {
        id: 'luis.appVersionsPage.browserTitle',
        defaultMessage: 'LUIS: App versions'
    },
    pageTitle: {
        id: 'luis.appVersionsPage.pageTitle',
        defaultMessage: 'Versions'
    },
    renameAppVersion: {
        id: 'luis.appVersionsPage.renameAppVersion',
        defaultMessage: 'Rename version'
    },
    importAppVersion: {
        id: 'luis.appVersionsPage.importAppVersion',
        defaultMessage: 'Import new app version'
    },
    deleteAppVersionModalTitle: {
        id: 'luis.appVersionsPage.deleteAppVersionModalTitle',
        defaultMessage: 'Delete selected version(s)?'
    },
    deleteAppVersionModalDescription: {
        id: 'luis.appVersionsPage.deleteAppVersionModalDescription',
        defaultMessage: 'Are you sure you want to Delete the selected version(s)?'
    },
    activateVersionToastStart: {
        id: 'luis.appVersionsPage.activateVersionToastStart',
        defaultMessage: 'Activating version ...'
    },
    activateVersionToastSuccess: {
        id: 'luis.appVersionsPage.activateVersionToastSuccess',
        defaultMessage: 'Activate version completed'
    },
    activateVersionToastFailed: {
        id: 'luis.appVersionsPage.activateVersionToastFailed',
        defaultMessage: 'Activate version failed'
    },
    deleteVersionToastStart: {
        id: 'luis.appVersionsPage.deleteVersionToastStart',
        defaultMessage: 'Deleting version(s) ...'
    },
    deleteVersionToastSuccess: {
        id: 'luis.appVersionsPage.deleteVersionToastSuccess',
        defaultMessage: 'Delete version(s) completed'
    },
    deleteVersionToastFailed: {
        id: 'luis.appVersionsPage.deleteVersionToastFailed',
        defaultMessage: 'Delete version(s) failed'
    },
    cloneVersionToastStart: {
        id: 'luis.appVersionsPage.cloneVersionToastStart',
        defaultMessage: 'Cloning version ...'
    },
    cloneVersionToastSuccess: {
        id: 'luis.appVersionsPage.cloneVersionToastSuccess',
        defaultMessage: 'Clone version completed'
    },
    cloneVersionToastFailed: {
        id: 'luis.appVersionsPage.cloneVersionToastFailed',
        defaultMessage: 'Clone version failed'
    },
    importVersionToastStart: {
        id: 'luis.appVersionsPage.importVersionToastStart',
        defaultMessage: 'Importing version ...'
    },
    importVersionToastSuccess: {
        id: 'luis.appVersionsPage.importVersionToastSuccess',
        defaultMessage: 'Import version completed'
    },
    importVersionToastFailed: {
        id: 'luis.appVersionsPage.importVersionToastFailed',
        defaultMessage: 'Import version failed'
    },
    renameVersionToastStart: {
        id: 'luis.appVersionsPage.renameVersionToastStart',
        defaultMessage: 'Renaming version ...'
    },
    renameVersionToastSuccess: {
        id: 'luis.appVersionsPage.renameVersionToastSuccess',
        defaultMessage: 'Rename version completed'
    },
    renameVersionToastFailed: {
        id: 'luis.appVersionsPage.renameVersionToastFailed',
        defaultMessage: 'Rename version failed'
    },
    exportVersionToastStart: {
        id: 'luis.appVersionsPage.exportVersionToastStart',
        defaultMessage: 'Exporting version ...'
    },
    exportVersionToastSuccess: {
        id: 'luis.appVersionsPage.exportVersionToastSuccess',
        defaultMessage: 'Export version completed'
    },
    exportVersionToastFailed: {
        id: 'luis.appVersionsPage.exportVersionToastFailed',
        defaultMessage: 'Export version failed'
    },
    emptyTablePlaceholder: {
        id: 'luis.appVersionsPage.emptyTablePlaceholder',
        defaultMessage: 'There are no versions found.'
    }
});
